module.exports = __webpack_public_path__ + "img/Hypoxia-OPSCC_PMID37704757.64313834.png";